export function toLogin(_this){
		
	_this.$confirm('此操作需要登录网站, 是否要去登录?', '提示', {
	  confirmButtonText: '登录',
	  cancelButtonText: '取消',
	  type: 'warning'
	}).then(() => {
	  _this.$router.push('/login')
	}).catch(() => {
			   
	});
}